import { PatientPayersActions } from 'src/redux/actions/constant';

const {
  CREATE_PATIENT_PAYER_REQUEST,
  CREATE_PATIENT_PAYER_SUCCESS,
  CREATE_PATIENT_PAYER_FAILURE,
  CREATE_PATIENT_PAYER_RESET,
} = PatientPayersActions;

const initialState: object = {
  response: null,
  loading: false,
  isSuccess: false,
};

export const createPatientPayerReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case CREATE_PATIENT_PAYER_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: true,
      };
    }

    case CREATE_PATIENT_PAYER_FAILURE:
      return {
        ...state,
        response: action.payload,
        loading: false,
        isSuccess: false,
      };

    case CREATE_PATIENT_PAYER_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case CREATE_PATIENT_PAYER_RESET:
      return initialState;

    default:
      return state;
  }
};
